import { htmlSafe } from "@ember/template";
import { isPresent } from "@ember/utils";
import Component from "@glimmer/component";

interface Signature {
  Element: HTMLDivElement;
  Args: {
    value?: unknown;
    actionLabel?: string;
    actionIconName?: string;
    onClick?: () => void;
  };
  Blocks: { default: []; title: []; body: [] };
}

export default class TitledLabelComponent extends Component<Signature> {
  get noValueArgument() {
    return !("value" in this.args);
  }

  get valueIsPresent() {
    return isPresent(this.args.value);
  }

  get showBody() {
    return this.noValueArgument || this.valueIsPresent;
  }

  get value() {
    // @ts-expect-error the "value" arg can be undefined, we need to change this implementation
    return htmlSafe(this.args.value);
  }
}
